import React from 'react';

export const identificationLanguageContent = {
    'identification': {
        'en': 'Identification Card',
        'ar': 'بطاقة الهوية',
        'ht': 'Kat Idantifikasyon',
        'pl': 'Karta identyfikacyjna',
        'pt': 'Cartão de identificação',
        'sr': 'Лична карта',
        'es': 'Tarjeta de identificación',
        'vi': 'Thẻ nhận dạng - Chứng minh nhân dân',
        'zh': '身份证',
        'ne': 'परिचय पत्र'
    },
    'identity-question': {
        'en': <span>Does the Patient have an <b className='font-semibold'>Identification</b> Card?</span>,
        'ar': <span className='dir-rtl'>هل يمتلك المريض <b className='font-semibold'>بطاقة هوية</b>؟</span>,
        'ht': <span>Èske Pasyan an gen yon <b className='font-semibold'>Kat Idantifikasyon</b>?</span>,
        'pl': <span>Czy Pacjent posiada <b className='font-semibold'>Kartę identyfikacyjną</b>?</span>,
        'pt': <span>O paciente possui um cartão de <b className='font-semibold'>identificação</b>?</span>,
        'sr': <span>Да ли пацијент има <b className='font-semibold'>идентификациону картицу</b>?</span>,
        'es': <span>¿Tiene el Paciente una Tarjeta de <b className='font-semibold'>Identificación</b>?</span>,
        'vi': <span>Bệnh nhân có Thẻ <b className='font-semibold'>Nhận dạng</b> không?</span>,
        'zh': <span>患者是否有<b className='font-semibold'>身份证</b>卡？</span>,
        'ne': <span>के बिरामीसँग <b className='font-semibold'>पहिचान कार्ड</b> छ?</span>
    },
    'yes': {
        'en': 'Yes',
        'ar': 'نعم',
        'ht': 'Wi',
        'pl': 'Tak',
        'pt': 'Sim',
        'sr': 'да',
        'es': 'Sí',
        'vi': 'Đúng',
        'zh': '是的',
        'ne': 'हो'
    },
    'no': {
        'en': 'No',
        'ar': 'لا',
        'ht': 'Non',
        'pl': 'NIE',
        'pt': 'Não',
        'sr': 'Не',
        'es': 'No',
        'vi': 'KHÔNG',
        'zh': '不',
        'ne': 'छैन'
    },
    'photo-choice': {
        'en': <p className='text-justify text-[#333] text-sm leading-5'>We need Images of your <b>Identification card</b>. Would you like to <b className='text-primary'>Upload</b> Images stored on your device or 
            <b className='text-primary'> Take a Photo</b> of your card(s) using your device?</p>,
        'ar': <p className='text-justify text-[#333] text-sm leading-5'>نحتاج إلى صور <b>بطاقة الهوية</b> الخاصة بك. هل ترغب في <b className='text-primary'>تحميل</b> الصور المخزنة على جهازك أم
            <b className='text-primary'> التقط صورة</b> لبطاقتك (بطاقاتك) باستخدام جهازك؟</p>,
        'ht': <p className='text-justify text-[#333] text-sm leading-5'>Nou bezwen imaj <b>Kat idantifikasyon ou</b>. Èske ou ta renmen <b className='text-primary'>Télécharger</b> Imaj ki estoke sou aparèy ou an oswa
            <b className='text-primary'> Pran yon foto</b> kat ou (yo) lè l sèvi avèk aparèy ou a?</p>,
        'pl': <p className='text-justify text-[#333] text-sm leading-5'>Potrzebujemy zdjęć Twojej <b>dowód osobisty</b>. Czy chcesz <b className='text-primary'>przesłać</b> obrazy zapisane na Twoim urządzeniu lub
            <b className='text-primary'> Zrobić zdjęcie</b> swoich kart za pomocą urządzenia?</p>,
        'pt': <p className='text-justify text-[#333] text-sm leading-5'>Precisamos de imagens do seu <b>cartão de identificação</b>. Você gostaria de <b className='text-primary'>fazer upload</b> de imagens armazenadas em seu dispositivo ou
            <b className='text-primary'>Tirar uma foto</b> do(s) seu(s) cartão(ões) usando seu dispositivo?</p>,
        'sr': <p className='text-justify text-[#333] text-sm leading-5'>Потребне су нам слике ваше <b>личне карте</b>. Да ли желите да <b className='text-primary'>отпремите</b> слике сачуване на вашем уређају или
            <b className='text-primary'> Снимите фотографију</b> своје картице помоћу уређаја?</p>,
        'es': <p className='text-justify text-[#333] text-sm leading-5'>Necesitamos imágenes de su <b>tarjeta de identificación</b>. ¿Le gustaría <b className='text-primary'>Subir</b> imágenes almacenadas en su dispositivo o
            <b className='text-primary'> ¿Tomar una foto</b> de su(s) tarjeta(s) usando su dispositivo?</p>,
        'vi': <p className='text-justify text-[#333] text-sm leading-5'>Chúng tôi cần Hình ảnh <b>Chứng minh nhân dân</b> của bạn. Bạn có muốn <b className='text-primary'>Tải lên</b> Hình ảnh được lưu trữ trên thiết bị của bạn hoặc
            <b className='text-primary'> Chụp ảnh</b> thẻ của bạn bằng thiết bị của bạn?</p>,
        'zh': <p className='text-justify text-[#333] text-sm leading-5'>我们需要您的<b>身份证图片</b>。您想要<b className='text-primary'>上传</b>您设备上存储的图像吗？
            使用您的设备<b className='text-primary'>拍摄您的卡的照片</b>？</p>,
        'ne': <p className='text-justify text-[#333] text-sm leading-5'>हामीलाई तपाईंको <b>पहिचान कार्ड</b> को छविहरू चाहिन्छ। के तपाईं आफ्नो यन्त्रमा भण्डारण गरिएका छविहरू <b className='text-primary'>अपलोड</b> गर्न चाहनुहुन्छ वा
            आफ्नो यन्त्र प्रयोग गरेर आफ्नो कार्ड(हरू) को <b className='text-primary'> फोटो खिच्नुहोस्</b>?</p>
    },
    'upload': {
        'en': 'Upload',
        'ar': 'رفع',
        'ht': 'Telechaje',
        'pl': 'Wgrywać',
        'pt': 'Carregar',
        'sr': 'Отпремити',
        'es': 'Subir',
        'vi': 'Tải lên',
        'zh': '上传',
        'ne': 'अपलोड गर्नुहोस्'
    },
    'take-a-photo': {
        'en': 'Take a photo',
        'ar': 'التقاط صورة',
        'ht': 'Pran yon foto',
        'pl': 'Robić zdjęcie',
        'pt': 'Tire uma foto',
        'sr': 'Сликати',
        'es': 'Toma una foto',
        'vi': 'Chụp ảnh',
        'zh': '拍个照',
        'ne': 'फोटो खिच्नुहोस्'
    },
    'identity-front-upload': {
        'en': <p className='text-justify text-[#333] text-sm leading-5'>Select the Patient <b>identification card</b> <b className='text-primary'>FRONT</b> image to upload.</p>    ,
        'ar': <p className='dir-rtl text-[#333] text-sm leading-5'>حدد <b>بطاقة هوية</b> المريض <b className='text-primary'>الأمامية</b> لتحميلها.</p>,
        'ht': <p className='text-justify text-[#333] text-sm leading-5'>Chwazi <b>kat idantifikasyon Pasyan an</b> <b className='text-primary'>DEVAN</b> imaj pou telechaje.</p>,
        'pl': <p className='text-justify text-[#333] text-sm leading-5'>Wybierz obraz <b>karty identyfikacyjnej</b> <b className='text-primary'>PRZEDNIEJ</b> pacjenta, który chcesz przesłać.</p>,
        'pt': <p className='text-justify text-[#333] text-sm leading-5'>Selecione a imagem do <b>cartão de identificação</b> <b className='text-primary'>FRENTE</b> do paciente para fazer upload.</p>,
        'sr': <p className='text-justify text-[#333] text-sm leading-5'>Изаберите слику <b>идентификационе картице</b> <b className='text-primary'>ПРЕДЊЕ</b> пацијента за отпремање.</p>,
        'es': <p className='text-justify text-[#333] text-sm leading-5'>Seleccione la imagen <b>tarjeta de identificación</b> <b className='text-primary'>Delantero</b> del paciente para cargar.</p>,
        'vi': <p className='text-justify text-[#333] text-sm leading-5'>Chọn hình ảnh <b>thẻ nhận dạng bệnh nhân</b> <b className='text-primary'>TRƯỚC</b> để tải lên.</p>,
        'zh': <p className='text-justify text-[#333] text-sm leading-5'>选择要上传的患者<b>身份证</b><b className='text-primary'>正面</b>图像。</p>,
        'ne': <p className='text-justify text-[#333] text-sm leading-5'>अपलोड गर्न बिरामीको <b>पहिचान कार्ड</b> <b className='text-primary'>अगाडि</b> छवि चयन गर्नुहोस्।</p>
    },
    'front': {
        'en': 'Front',
        'ar': 'أمام',
        'ht': 'DEVAN',
        'pl': 'PRZÓD',
        'pt': 'FRENTE',
        'sr': 'ФРОНТ',
        'es': 'Delantero',
        'vi': 'ĐẰNG TRƯỚC',
        'zh': '正面',
        'ne': 'अगाडि'
    },
    'browse': {
        'en': 'Browse',
        'ar': 'تصفح',
        'ht': 'Browse',
        'pl': 'Przeglądać',
        'pt': 'Navegar',
        'sr': 'Прегледај',
        'es': 'Navegar',
        'vi': 'Duyệt qua',
        'zh': '浏览',
        'ne': 'ब्राउज गर्नुहोस्'
    },
    'file-format': {
        'en': 'File Format: JPEG/PNG; Max Size: 5MB',
        'ar': 'تنسيق الملف: جبيغ/بينغ؛ الحد الأقصى للحجم: 5 ميجابايت',
        'ht': 'Fòma fichye: JPEG/PNG; Gwosè maksimòm: 5MB',
        'pl': 'Format pliku: JPEG/PNG; Maksymalny rozmiar: 5MB',
        'pt': 'Formato de arquivo: JPEG/PNG; Tamanho máximo: 5 MB',
        'sr': 'Формат датотеке: ЈПЕГ/ПНГ; Максимална величина: 5МБ',
        'es': 'Formato de archivo: JPEG/PNG; Tamaño máximo: 5 MB',
        'vi': 'Định dạng tệp: JPEG/PNG; Kích thước tối đa: 5 MB',
        'zh': '文件格式：JPEG/PNG；最大大小：5MB',
        'ne': 'फाइल ढाँचा: JPEG/PNG; अधिकतम आकार: 5MB'
    },
    'detail-info': {
        'en': <p className='font-normal text-sm text-[#333] text-justify break-words my-[18px]'>Please verify the <b>Data</b> captured was correct. You can select the <b>Fields</b> below to <b>Edit</b> them. 
            Press <b className='text-primary'>Next</b> when ready to continue or <b className='text-primary'>Back</b> to upload another image.</p>,
        'ar': <p className='font-normal text-sm text-[#333] text-justify break-words my-[18px] dir-rtl'>يُرجى التحقق من صحة <b>البيانات</b> التي تم التقاطها. يمكنك تحديد <b>الحقول</b> أدناه <b>لتحريرها</b> منها.
            اضغط على <b className='text-primary'>التالي</b> عندما تكون مستعدًا للمتابعة أو على <b className='text-primary'>رجوع</b> لتحميل صورة أخرى.</p>,
        'ht': <p className='font-normal text-sm text-[#333] text-justify break-words my-[18px]'>Tanpri verifye <b>Done</b> yo te pran yo te kòrèk. Ou ka chwazi <b>Jaden</b> ki anba yo pou <b>Edite</b> yo.
            Peze <b className='text-primary'>Next</b> lè w pare pou kontinye oswa <b className='text-primary'>Retounen</b> pou telechaje yon lòt imaj.</p>,
        'pl': <p className='font-normal text-sm text-[#333] text-justify break-words my-[18px]'>Sprawdź, czy przechwycone <b>dane</b> są prawidłowe. Możesz wybrać <b>pola</b> poniżej, aby je <b>edytować</b>.
            Naciśnij <b className='text-primary'>Dalej</b>, aby kontynuować, lub <b className='text-primary'>Wstecz</b>, aby przesłać kolejny obraz.</p>,
        'pt': <p className='font-normal text-sm text-[#333] text-justify break-words my-[18px]'>Verifique se os <b>dados</b> capturados estão corretos. Você pode selecionar os <b>Campos</b> abaixo para <b>Editá-los</b>.
            Pressione <b className='text-primary'>Avançar</b> quando estiver pronto para continuar ou <b className='text-primary'>Voltar</b> para fazer upload de outra imagem.</p>,
        'sr': <p className='font-normal text-sm text-[#333] text-justify break-words my-[18px]'>Молимо проверите да су <b>Подаци</b> ухваћени тачни. Можете да изаберете <b>Поља</b> у наставку да бисте их <b>изменили</b>.
            Притисните <b className='text-primary'>Даље</b> када сте спремни да наставите или <b className='text-primary'>Назад</b> да бисте отпремили другу слику.</p>,
        'es': <p className='font-normal text-sm text-[#333] text-justify break-words my-[18px]'>Verifique que los <b>datos</b> capturados sean correctos. Puede seleccionar los <b>Campos</b> a continuación para <b>Editarlos</b>.
            Presione <b className='text-primary'>Siguiente</b> cuando esté listo para continuar o <b className='text-primary'>Atrás</b> para cargar otra imagen.</p>,
        'vi': <p className='font-normal text-sm text-[#333] text-justify break-words my-[18px]'>Vui lòng xác minh <b>Dữ liệu</b> được thu thập là chính xác. Bạn có thể chọn <b>Trường</b> bên dưới để <b>Chỉnh sửa</b> chúng.
            Nhấn <b className='text-primary'>Tiếp theo</b> khi sẵn sàng tiếp tục hoặc <b className='text-primary'>Quay lại</b> để tải lên hình ảnh khác.</p>,
        'zh': <p className='font-normal text-sm text-[#333] text-justify break-words my-[18px]'>请验证捕获的<b>数据</b>是否正确。您可以选择下面的<b>字段</b>来<b>编辑</b>它们。
            准备好继续时按<b className='text-primary'>下一步</b>，或按<b className='text-primary'>后退</b>上传另一张图像。</p>,
        'ne': <p className='font-normal text-sm text-[#333] text-justify break-words my-[18px]'>कृपया क्याप्चर गरिएको <b>डेटा</b> सही थियो भनी प्रमाणित गर्नुहोस्। तपाईंले तिनीहरूलाई <b>सम्पादन</b> गर्न तल <b>क्षेत्रहरू</b> चयन गर्न सक्नुहुन्छ।
            जारी राख्न तयार हुँदा <b className='text-primary'>अर्को</b> थिच्नुहोस् वा अर्को छवि अपलोड गर्न <b className='text-primary'>पछाडि</b> थिच्नुहोस्।</p>
    },
    'card-issuer': {
        'en': 'Card Issuer',
        'ar': 'مصدر البطاقة',
        'ht': 'Emetteur Kat',
        'pl': 'Wydawca karty',
        'pt': 'Emissor de cartão',
        'sr': 'Издавалац картице',
        'es': 'Emisor de la tarjeta',
        'vi': 'Tổ chức phát hành thẻ',
        'zh': '信用卡发行商',
        'ne': 'कार्ड जारीकर्ता'
    },
    'card-type': {
        'en': 'Card Issuer',
        'ar': 'نوع البطاقة',
        'ht': 'Kalite kat',
        'pl': 'Typ karty',
        'pt': 'Tipo de carta',
        'sr': 'Тип картице',
        'es': 'Tipo de tarjeta',
        'vi': 'Loại thẻ',
        'zh': '卡的种类',
        'ne': 'कार्ड प्रकार'
    },
    'card-number': {
        'en': 'Card Number',
        'ar': 'رقم البطاقة',
        'ht': 'Nimewo kat',
        'pl': 'Numer karty',
        'pt': 'Número do cartão',
        'sr': 'Број картице',
        'es': 'Número de tarjeta',
        'vi': 'Số thẻ',
        'zh': '卡号',
        'ne': 'कार्ड नम्बर'
    },
    'expiration-date': {
        'en': 'Expiration Date',
        'ar': 'تاريخ انتهاء الصلاحية',
        'ht': 'Dat ekspirasyon',
        'pl': 'Termin ważności',
        'pt': 'Data de validade',
        'sr': 'Рок трајања',
        'es': 'Fecha de caducidad',
        'vi': 'Ngày hết hạn',
        'zh': '截止日期',
        'ne': 'म्याद समाप्त हुने मिति'
    },
    'take-photo': {
        'en': <p className='text-justify text-[#333] text-sm leading-5'>Center the <b>Front</b> of your identification card in the <b>Viewport</b> and take a photo by touching the button below. Press 
            <b className='text-primary'> Next</b> if you are satisfied with the image captured.</p>   ,
        'ar': <p className='text-justify text-[#333] text-sm leading-5'>قم بتوسيط <b>الجزء الأمامي</b> من بطاقة الهوية الخاصة بك في <b>منفذ العرض</b> والتقط صورة عن طريق لمس الزر أدناه. يضعط
            <b className='text-primary'> التالي</b> إذا كنت راضيًا عن الصورة الملتقطة.</p>,
        'ht': <p className='text-justify text-[#333] text-sm leading-5'>Santire <b>Devan</b> kat idantifikasyon w lan nan <b>Vizyas</b> epi pran yon foto lè w touche bouton ki anba a. Peze
            <b className='text-primary'> Apre sa</b> si ou satisfè ak imaj ki te kaptire a.</p>,
        'pl': <p className='text-justify text-[#333] text-sm leading-5'>Wyśrodkuj <b>przód</b> swojego dowodu osobistego w <b>Widoku</b> i zrób zdjęcie, dotykając przycisku poniżej. Naciskać
            <b className='text-primary'> Dalej</b>, jeśli jesteś zadowolony z wykonanego obrazu.</p>,
        'pt': <p className='text-justify text-[#333] text-sm leading-5'>Centre a <b>Frente</b> do seu cartão de identificação na <b>Visualização</b> e tire uma foto tocando no botão abaixo. Imprensa
            <b className='text-primary'> Próximo</b> se você estiver satisfeito com a imagem capturada.</p>,
        'sr': <p className='text-justify text-[#333] text-sm leading-5'>Центрирајте <b>Предњу страну</b> своје личне карте у <b>Виевпорт</b> и снимите фотографију додиром на дугме испод. Притисните
            <b className='text-primary'> Следећи</b> ако сте задовољни снимљеном сликом.</p>,
        'es': <p className='text-justify text-[#333] text-sm leading-5'>Centra el <b>Frente</b> de tu tarjeta de identificación en la <b>Ventana</b> y toma una foto tocando el botón de abajo. Prensa
            <b className='text-primary'> Siguiente</b> si está satisfecho con la imagen capturada.</p>,
        'vi': <p className='text-justify text-[#333] text-sm leading-5'>Căn giữa <b>Mặt trước</b> thẻ nhận dạng của bạn trong <b>Khung nhìn</b> và chụp ảnh bằng cách chạm vào nút bên dưới. Nhấn
            <b className='text-primary'> Tiếp theo</b> nếu bạn hài lòng với hình ảnh đã chụp.</p>,
        'zh': <p className='text-justify text-[#333] text-sm leading-5'>将身份证的<b>正面</b>置于<b>视口</b>中心，然后触摸下面的按钮拍照。按
            <b className='text-primary'>下一步</b>如果您对捕获的图像感到满意。</p>,
        'ne': <p className='text-justify text-[#333] text-sm leading-5'>तपाईंको पहिचान कार्डको <b>अगाडि</b> <b>भ्युपोर्ट</b> मा केन्द्रित गर्नुहोस् र तलको बटन छोएर फोटो खिच्नुहोस्। थिच्नुहोस्
            <b className='text-primary'> अर्को</b> यदि तपाईं खिचिएको छविसँग सन्तुष्ट हुनुहुन्छ भने।</p>
    },
    "Enter card number": {
        'en': 'Enter card number',
        'ar': 'أدخل رقم البطاقة',
        'ht': 'Antre nimewo kat la',
        'pl': 'Wprowadź numer karty',
        'pt': 'Digite o número do cartão',
        'sr': 'Унесите број картице',
        'es': 'Introduce el número de tarjeta',
        'vi': 'Nhập số thẻ',
        'zh': '输入卡号',
        'ne': 'कार्ड नम्बर प्रविष्ट गर्नुहोस्'
    },
    "Select an option": {
        'en': "Select an option",
        'ar': 'حدد اختيارا',
        'ht': 'Chwazi yon opsyon',
        'pl': 'Wybierz opcję',
        'pt': 'Selecione uma opção',
        'sr': 'Изаберите опцију',
        'es': 'Seleccione una opción',
        'vi': 'Chọn một tùy chọn',
        'zh': '选择一个选项',
        'ne': 'एक विकल्प चयन गर्नुहोस्'
    }
}